<ng-container *appTranslate="let t">
  <p-panel header="Anmeldung zur Rezertifizierung des Gütezeichens" styleClass="w-[800px]">
    <div class="p-4 flex gap-4 items-start">
      <img
        class="w-1/5"
        ngSrc="../../../assets/partner/guete/RAL_GZ_FaireAnwerbungFair+Recruitment_RGB-518h.webp"
        width="200"
        height="350"
      />
      @if (message) {
        <div [innerHtml]="message"></div>
      } @else {
        <form class="w-full form" [formGroup]="form">
          <div class="col-span-6 col">
            <new-ui-inputtext [label]="t('organization.title')" [formControlName]="nameOf('organizationName')" />

            @if (form.controls.organizationName.errors?.required) {
              <p-message severity="error" variant="simple" size="small">{{ t("common.required") }}</p-message>
            }
          </div>

          <div class="col-span-6 col">
            <new-ui-dropdown
              [label]="t('organizationType.title')"
              [options]="organizationTypes$ | async"
              [formControlName]="nameOf('organizationType')"
            />

            @if (form.controls.organizationType.errors?.required) {
              <p-message severity="error" variant="simple" size="small">{{ t("common.required") }}</p-message>
            }
          </div>

          <div class="col-span-4 col">
            <new-ui-dropdown
              [label]="t('salutation.title')"
              [options]="salutations$ | async"
              [formControlName]="nameOf('salutation')"
            />

            @if (form.controls.salutation.errors?.required) {
              <p-message severity="error" variant="simple" size="small">{{ t("common.required") }}</p-message>
            }
          </div>

          <div class="col-span-4 col">
            <new-ui-inputtext [label]="t('firstName.title')" [formControlName]="nameOf('firstName')" />

            @if (form.controls.firstName.errors?.required) {
              <p-message severity="error" variant="simple" size="small">{{ t("common.required") }}</p-message>
            }
          </div>

          <div class="col-span-4 col">
            <new-ui-inputtext [label]="t('lastName.title')" [formControlName]="nameOf('lastName')" />

            @if (form.controls.lastName.errors?.required) {
              <p-message severity="error" variant="simple" size="small">{{ t("common.required") }}</p-message>
            }
          </div>

          <div class="col-span-6 col">
            <new-ui-inputtext [label]="t('email.title')" [formControlName]="nameOf('emailAddress')" />

            @if (form.controls.emailAddress.errors?.required) {
              <p-message severity="error" variant="simple" size="small">{{ t("common.required") }}</p-message>
            }
            @if (form.controls.emailAddress.errors?.pattern) {
              <p-message severity="error" variant="simple" size="small">{{ t("email.invalid") }}</p-message>
            }
            @if (form.errors?.emailAddressMismatch) {
              <p-message severity="error" variant="simple" size="small">{{ t("email.unequal") }}</p-message>
            }
          </div>

          <div class="col-span-6 col">
            <new-ui-inputtext
              [label]="t('email.title') + ' - Wiederholung'"
              [formControlName]="nameOf('emailAddress2')"
            />

            @if (form.controls.emailAddress2.errors?.pattern) {
              <p-message severity="error" variant="simple" size="small">{{ t("email.invalid") }}</p-message>
            }
            @if (form.errors?.emailAddressMismatch) {
              <p-message severity="error" variant="simple" size="small">{{ t("email.unequal") }}</p-message>
            }
          </div>
        </form>
      }
    </div>

    <ng-template #footer>
      <div class="row justify-end">
        @if (!message) {
          <new-ui-button
            [label]="t('login.title')"
            icon="icon-[mi--checkmark-medium]"
            [disabled]="form.invalid"
            (onClick)="submit($event)"
          />
        } @else {
          <new-ui-button [label]="buttonLabel" severity="secondary" icon="pi pi-arrow-left" (onClick)="back()" />
        }
      </div>
    </ng-template>
  </p-panel>
</ng-container>
